export default function isUserStatusLoggedInOrReinitializing({
  isUserLoggedIn,
  isFetching,
}: {
  isUserLoggedIn: boolean
  isFetching: boolean
}) {
  return [isUserLoggedIn, isFetching].some(Boolean)
}
